// The 20 operational regions from Pureworker_Lagos_Marketer_Regions_Map.html.
// Original addresses/coverage remain stored; boundary names need point evidence.
export const LAGOS_REGIONS = [
  {
    "id": "R01",
    "slug": "agege",
    "name": "Agege",
    "aliases": [
      "Agege town",
      "Pen Cinema",
      "Orile-Agege",
      "Dopemu"
    ],
    "description": "All of Agege LGA, including Agege town, Pen Cinema, Orile-Agege and Dopemu areas within the LGA boundary.",
    "point": [
      6.624647842,
      3.3165244013
    ]
  },
  {
    "id": "R02",
    "slug": "ajeromi-ifelodun",
    "name": "Ajeromi-Ifelodun",
    "aliases": [
      "Ajegunle",
      "Tolu",
      "Olodi-Apapa",
      "Amukoko",
      "Ijora-Badia"
    ],
    "description": "All of Ajeromi-Ifelodun LGA, including Ajegunle, Tolu, Olodi-Apapa, Amukoko and Ijora-Badia areas within the LGA boundary.",
    "point": [
      6.4557099196,
      3.3359027903
    ]
  },
  {
    "id": "R03",
    "slug": "alimosho",
    "name": "Alimosho",
    "aliases": [
      "Egbeda",
      "Ipaja",
      "Ayobo",
      "Idimu",
      "Ikotun",
      "Igando",
      "Agbado-Oke-Odo",
      "Iyana Ipaja"
    ],
    "description": "All of Alimosho LGA, including Egbeda, Ipaja, Ayobo, Idimu, Ikotun, Igando and Agbado-Oke-Odo areas within the LGA boundary.",
    "point": [
      6.5833317894,
      3.2542234561
    ]
  },
  {
    "id": "R04",
    "slug": "amuwo-odofin",
    "name": "Amuwo-Odofin",
    "aliases": [
      "Amuwo Odofin",
      "Festac Town",
      "Festac",
      "Satellite Town",
      "Kirikiri"
    ],
    "description": "All of Amuwo-Odofin LGA, including Festac, Satellite Town, Kirikiri and the source riverine/island components; retained operational residual coverage is identified separately.",
    "point": [
      6.4465804703,
      3.2747899406
    ]
  },
  {
    "id": "R05",
    "slug": "apapa",
    "name": "Apapa",
    "aliases": [
      "Apapa town"
    ],
    "description": "All of Apapa LGA, including Apapa town, port and quay areas within its boundary. Olodi-Apapa/Ajegunle addresses require their correct Ajeromi-Ifelodun context.",
    "point": [
      6.4384858029,
      3.3760249311
    ]
  },
  {
    "id": "R06",
    "slug": "badagry",
    "name": "Badagry",
    "aliases": [
      "Badagry town",
      "Ajara",
      "Seme",
      "Olorunda",
      "Iworo",
      "Ajido"
    ],
    "description": "All of Badagry LGA, including Badagry town, Ajara, Seme/Apa, Olorunda/Iworo/Ajido and the source coastal/riverine components.",
    "point": [
      6.4455348969,
      2.966172228
    ]
  },
  {
    "id": "R07",
    "slug": "epe",
    "name": "Epe",
    "aliases": [
      "Epe town",
      "Agbowa",
      "Ikosi-Ejirin",
      "Eredo",
      "Noforija",
      "Ilara",
      "Poka"
    ],
    "description": "All of Epe LGA, including Epe town, Agbowa/Ikosi-Ejirin, Eredo/Noforija, Ilara/Poka and the source rural, waterfront and riverine components.",
    "point": [
      6.5293098499,
      4.0488672121
    ]
  },
  {
    "id": "R08",
    "slug": "eti-osa",
    "name": "Eti-Osa",
    "aliases": [
      "Eti Osa",
      "Ikoyi",
      "Obalende",
      "Victoria Island",
      "VI",
      "V.I.",
      "Oniru",
      "Lekki Phase 1",
      "Lekki Phase 2",
      "Agungi",
      "Ikota",
      "Ajah",
      "Badore",
      "Abraham Adesanya",
      "Ilasan"
    ],
    "description": "All of Eti-Osa LGA, including Ikoyi/Obalende, Victoria Island/Oniru, Lekki Phase 1/Ikate, Agungi/Ikota and Ajah/Badore areas within the LGA boundary, plus explicitly retained operational residual coverage.",
    "point": [
      6.4572553496,
      3.581727455
    ]
  },
  {
    "id": "R09",
    "slug": "ibeju-lekki",
    "name": "Ibeju-Lekki",
    "aliases": [
      "Ibeju Lekki",
      "Abijo",
      "Awoyaya",
      "Lakowe",
      "Bogije",
      "Ibeju",
      "Eleko",
      "Akodo"
    ],
    "description": "All of Ibeju-Lekki LGA, including source areas around Abijo/Awoyaya, Lakowe/Bogije, Ibeju/Eleko/Akodo and the Lekki port/eastern coastal corridor, plus retained operational residual coverage.",
    "point": [
      6.4574389026,
      3.8513908243
    ]
  },
  {
    "id": "R10",
    "slug": "ifako-ijaiye",
    "name": "Ifako-Ijaiye",
    "aliases": [
      "Ifako Ijaiye",
      "Iju-Ishaga",
      "Iju Ishaga",
      "Ojokoro",
      "Alakuko"
    ],
    "description": "All of Ifako-Ijaiye LGA, including its core, Iju-Ishaga and Ojokoro/Alakuko areas. Ogba, Alagbado and other boundary names require source-LGA or point confirmation.",
    "point": [
      6.6635014426,
      3.3179432223
    ]
  },
  {
    "id": "R11",
    "slug": "ikeja",
    "name": "Ikeja",
    "aliases": [
      "Ikeja GRA",
      "Alausa",
      "Opebi",
      "Oregun",
      "Onigbongbo",
      "Allen Avenue"
    ],
    "description": "The entire Ikeja LGA as one region, including Ikeja GRA, Alausa, Opebi/Oregun and Onigbongbo/Ojodu areas within the source boundary. No part of Ikeja is separately assigned.",
    "point": [
      6.6070529286,
      3.3483409322
    ]
  },
  {
    "id": "R12",
    "slug": "ikorodu",
    "name": "Ikorodu",
    "aliases": [
      "Agric",
      "Odogunyan",
      "Maya",
      "Igbogbo",
      "Baiyeku",
      "Ijede",
      "Gberigbe",
      "Imota"
    ],
    "description": "The entire Ikorodu LGA as one region: Ikorodu town/Agric/Ebute, Odogunyan/Maya, Igbogbo/Baiyeku, Ijede/Gberigbe, Imota and all source rural/riverine components.",
    "point": [
      6.5996908643,
      3.5936895835
    ]
  },
  {
    "id": "R13",
    "slug": "kosofe",
    "name": "Kosofe",
    "aliases": [
      "Ketu",
      "Alapere",
      "Ojota",
      "Oworonshoki",
      "Ikosi",
      "Isheri",
      "Magodo"
    ],
    "description": "All of Kosofe LGA, including Ketu, Alapere, Ojota, Oworonshoki and Ikosi/Isheri/Magodo areas within its boundary; border/postal names require confirmation.",
    "point": [
      6.5870732258,
      3.3921111135
    ]
  },
  {
    "id": "R14",
    "slug": "lagos-island",
    "name": "Lagos Island",
    "aliases": [
      "Idumota",
      "Marina",
      "Broad Street",
      "Isale-Eko"
    ],
    "description": "All of Lagos Island LGA, including Idumota, Marina, Broad Street, Isale-Eko and the source island/waterfront components. Generic Lagos is not a Lagos Island address.",
    "point": [
      6.4526186678,
      3.3959635705
    ]
  },
  {
    "id": "R15",
    "slug": "lagos-mainland",
    "name": "Lagos Mainland",
    "aliases": [
      "Yaba",
      "Ebute Metta",
      "Ebute Meta",
      "Iwaya",
      "Akoka",
      "Sabo",
      "Onike"
    ],
    "description": "All of Lagos Mainland LGA, including Yaba, Ebute-Metta, Iwaya and the source waterfront components, plus retained operational residual coverage.",
    "point": [
      6.4970924722,
      3.3840937059
    ]
  },
  {
    "id": "R16",
    "slug": "mushin",
    "name": "Mushin",
    "aliases": [
      "Idi-Araba",
      "Idi-Oro",
      "Odi-Olowo",
      "Ojuwoye"
    ],
    "description": "All of Mushin LGA, including Mushin, Idi-Araba, Idi-Oro and Odi-Olowo/Ojuwoye areas within its boundary; Ilupeju/Palmgrove/Itire border names require confirmation.",
    "point": [
      6.5290572227,
      3.3516893157
    ]
  },
  {
    "id": "R17",
    "slug": "ojo",
    "name": "Ojo",
    "aliases": [
      "Alaba",
      "Okokomaiko",
      "Iba",
      "Oto-Awori",
      "Ijanikin"
    ],
    "description": "All of Ojo LGA, including Ojo/Alaba/Okokomaiko, Iba, Oto-Awori/Ijanikin and all source coastal, island and riverine components.",
    "point": [
      6.4648548453,
      3.1652581929
    ]
  },
  {
    "id": "R18",
    "slug": "oshodi-isolo",
    "name": "Oshodi-Isolo",
    "aliases": [
      "Oshodi Isolo",
      "Oshodi",
      "Mafoluku",
      "Isolo",
      "Ejigbo",
      "Okota",
      "Ago Palace"
    ],
    "description": "All of Oshodi-Isolo LGA, including Oshodi/Mafoluku, Isolo and Ejigbo areas within the source boundary.",
    "point": [
      6.535217268,
      3.3125294255
    ]
  },
  {
    "id": "R19",
    "slug": "shomolu",
    "name": "Shomolu",
    "aliases": [
      "Somolu",
      "Bariga"
    ],
    "description": "All of Shomolu (also spelled Somolu) LGA, including Shomolu and Bariga areas within the source boundary.",
    "point": [
      6.5409989856,
      3.38336616
    ]
  },
  {
    "id": "R20",
    "slug": "surulere",
    "name": "Surulere",
    "aliases": [
      "Coker",
      "Aguda",
      "Itire-Ikate",
      "Ojuelegba"
    ],
    "description": "All of Surulere LGA, including Surulere town, Coker/Aguda and Itire-Ikate areas within its boundary. Shared or postal locality names remain review cases.",
    "point": [
      6.4902526217,
      3.344019168
    ]
  }
] as const;
const fold = (value: string) => value.toLowerCase().replace(/[. _-]+/g, ' ').trim();
export function regionForArea(value: unknown) {
  if (typeof value !== 'string') return undefined;
  const label = fold(value);
  return LAGOS_REGIONS.find(region => [region.slug, region.name, ...region.aliases].some(name => fold(name) === label));
}
export function regionSelections(values: unknown): string[] {
  return Array.isArray(values) ? Array.from(new Set(values.filter((value): value is string => typeof value === 'string').map(value => regionForArea(value)?.slug || value))) : [];
}
export function toggleRegion(values: string[], region: string, selected: boolean): string[] {
  const rest = values.filter(value => (regionForArea(value)?.slug || value) !== region);
  return selected ? [...rest, region] : rest;
}
